import {
    PortfolioModerationStatus,
    PortfolioModerationReason,
    PortfolioProjectModeration,
    PortfolioProjectFieldType,
} from '../../gql-operations/gql-generated';

export interface ViolatedFields {
    isHeaderViolated?: boolean;
    isDescriptionViolated?: boolean;
    violatedAttachmentIds?: string[];
}

interface PortfolioModerationDetails {
    isViolated: boolean;
    violationReason?: PortfolioModerationReason;
    violatedFields: ViolatedFields;
}

const getViolationReason = (reasons: PortfolioModerationReason[] | null): PortfolioModerationReason =>
    !reasons || !reasons.length || reasons.length > 1 ? PortfolioModerationReason.Unspecified : reasons[0];

export const getPortfolioModerationDetails = (
    moderation: PortfolioProjectModeration | null
): PortfolioModerationDetails => {
    if (moderation === null) {
        return {
            isViolated: false,
            violatedFields: {},
        };
    }

    const { status, reasons, violatedFields } = moderation;

    const violatedFieldsTemp: ViolatedFields = {};

    if (violatedFields?.length) {
        violatedFields.forEach((field) => {
            switch (field.type) {
                case PortfolioProjectFieldType.Title:
                    violatedFieldsTemp.isHeaderViolated = true;
                    break;

                case PortfolioProjectFieldType.Description:
                    violatedFieldsTemp.isDescriptionViolated = true;
                    break;

                case PortfolioProjectFieldType.ProjectItem:
                    if (field.attachmentId) {
                        if (!violatedFieldsTemp.violatedAttachmentIds) {
                            violatedFieldsTemp.violatedAttachmentIds = [];
                        }
                        violatedFieldsTemp.violatedAttachmentIds.push(field.attachmentId);
                    }
                    break;

                default:
                    break;
            }
        });
    }

    return {
        isViolated: status === PortfolioModerationStatus.Denied,
        violationReason: getViolationReason(reasons),
        violatedFields: violatedFieldsTemp,
    };
};
